import React, {useState} from 'react';
import Pagination from "./Pagination";
import Detail from "../detail/Detail";
import BaseModal from "../modal/BaseModal";
import {useDispatch} from "react-redux";

const getColumnValue = (row, column) => {
    const fieldParts = column.field.split('.');
    let value = row;
    for (const part of fieldParts) {
        if (value && value.hasOwnProperty(part)) {
            value = value[part];
        } else {
            value = null;
            break;
        }
    }
    return value;
};

const Table = ({
                   className,
                   columns,
                   data,
                   getDetailData,
                   pagination,
                   fetchData,
                   searchFields = [],
                   searchQuery = ''
               }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [clickedRow, setClickedRow] = useState(null);
    const [sortColumn, setSortColumn] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc'); // or 'desc'
    const dispatch = useDispatch();

    const fs = className && className.includes("fs") ? '' : ' fs-md';
    const tableSize = className && className.includes("table") ? '' : ' table-sm';
    const classes = `table${tableSize}${fs}${className ? ' ' + className : ''}`;

    let filteredData = [...data];

    if (searchQuery.trim() && searchFields.length > 0) {
        filteredData = filteredData.filter(row =>
            searchFields.some(field => {
                const value = getColumnValue(row, {field});
                return value && value.toString().toLowerCase().includes(searchQuery.toLowerCase());
            })
        );
    }

    const handleSort = (column) => {
        // Check if the clicked column is 'Actions', if so, do not sort

        if (column.disableSorting) {
            return;
        }
        if (sortColumn === column) {
            // If already sorting by this column, toggle direction
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            // If sorting by a different column, set the new column and direction
            setSortColumn(column);
            setSortDirection('asc'); // Default to ascending
        }
    };

    const handleRowClick = (row) => {
        if (!getDetailData) return; // prevents click when function not provided
        setIsModalOpen(true);
        setClickedRow(<Detail inline={true} columns={{lg: 9, xl: 7}} data={getDetailData({item: row})}/>);
        if (fetchData) {
            dispatch(fetchData({ id: row.id }));  // It only runs if you want to execute an API call on click
        }
    }

    const handleCloseModal = () => setIsModalOpen(false);
    const sortedData = [...filteredData];

    if (sortColumn) {
        sortedData.sort((a, b) => {
            const aValue = getColumnValue(a, sortColumn);
            const bValue = getColumnValue(b, sortColumn);

            // Detect if both values are valid dates
            const dateA = new Date(aValue);
            const dateB = new Date(bValue);

            const isDateA = !isNaN(dateA.getTime());
            const isDateB = !isNaN(dateB.getTime());

            if (isDateA && isDateB) {
                // Sort as Date
                return sortDirection === 'asc' ? dateA - dateB : dateB - dateA;
            }

            // Fallback: Sort string/number
            if (aValue < bValue) {
                return sortDirection === 'asc' ? -1 : 1;
            }
            if (aValue > bValue) {
                return sortDirection === 'asc' ? 1 : -1;
            }
            return 0;
        });
    }

    return (
        <>
            <div className='table-responsive'>
                <table className={classes}>
                    <thead>
                    <tr>
                        {columns.map((column, index) => (
                            <th key={index} onClick={() => handleSort(column)}
                                className={sortColumn === column ? `sort-arrow ${sortDirection}` : ''}
                                style={{textAlign: column.align}}>
                                {column.header}
                            </th>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {sortedData.map((row, rowIndex) => (
                        <tr key={rowIndex} onClick={() => handleRowClick(row)}>
                            {columns.map((column, columnIndex) => (
                                <td key={columnIndex}
                                    data-label={column.header !== "Actions" ? column.header + ": " : undefined}
                                    className={column.header === "Actions" ? "actions" : undefined}>
                                    {column.render ? column.render(row) : getColumnValue(row, column)}
                                </td>
                            ))}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            {pagination && <Pagination data={pagination}/>}
            <BaseModal isOpen={isModalOpen} onClose={handleCloseModal} title="Details">
                <div className="p-4">
                    {clickedRow}
                </div>
            </BaseModal>
        </>
    )
};

export default Table;
